import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserServices from "../../services/UserServices";
import CottageServices from "../../services/CottageServices";
import Pagetitle from "../../component/PageTitle";

function AddInvestor() {
  const navigate = useNavigate();
  const [cottage, setCottage] = useState([]);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    mobileNo: null, // Initialize as null instead of an empty string
    dateofbirth: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    accountHolderName: "",
    accountNo: "",
    bankName: "",
    ifscCode: "",
    investmentDate: "",
    property: "",
    investmentAmount: "",

  });


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  useEffect(() => {
    const fetchCottage = async () => {
      try {
        const res = await CottageServices.getCottage();
        if (res.status) {
          setCottage(res.data);
        } else {
          alert('Failed to fetch Cottage');
        }
      } catch (error) {
        console.error('Error fetching Cottage', error);
        alert('Failed to fetch Cottage');
      }
    };
    fetchCottage();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        // Check if the value is not null or undefined
        if (formValues[key] !== null && formValues[key] !== undefined) {
          formData.append(key, formValues[key]);
        }
      }

      const response = await UserServices.createInvestor(formData);

      alert("Investor Added Successfully");
      navigate("/investor-list");
    } catch (error) {
      console.error("Failed to add Investor", error);
      alert("Failed to add Investor");
    }
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box">
        <div className="container-box-top-header justify-content-between">
          <h4>Investor Information</h4>
          <div className="sub-title-box-right">
            <Link className="site-btn-green" to="/investor-list">
              Investor List
            </Link>
          </div>
        </div>
        <div className="container-box-inner px-4">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Name*</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formValues.name}
                      onChange={handleInputChange}
                      placeholder="Investor's full name"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Email*</label>
                    <input
                      type="text"
                      name="email"
                      className="form-control"
                      value={formValues.email}
                      onChange={handleInputChange}
                      placeholder="Enter email address"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Phone Number*</label>
                    <input
                      type="text"
                      name="mobileNo"
                      className="form-control"
                      maxLength={10}
                      minLength={10}
                      value={formValues.mobileNo}
                      onChange={handleInputChange}
                      placeholder="Enter Phone Number"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Date of Birth (Optional)</label>
                    <input
                      type="date"
                      name="dateOfBirth"
                      className="form-control"
                      value={formValues.dateOfBirth}
                      onChange={handleInputChange}
                      placeholder="Enter Phone Number"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Address*</label>
                    <input
                      type="text"
                      name="address"
                      className="form-control"
                      value={formValues.address}
                      onChange={handleInputChange}
                      placeholder="Enter Address"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>City*</label>
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      value={formValues.city}
                      onChange={handleInputChange}
                      placeholder="Enter City"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>State*</label>
                    <input
                      type="text"
                      name="state"
                      className="form-control"
                      value={formValues.state}
                      onChange={handleInputChange}
                      placeholder="Enter State"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Pincode*</label>
                    <input
                      type="text"
                      name="pincode"
                      className="form-control"
                      value={formValues.pincode}
                      onChange={handleInputChange}
                      placeholder="Enter Pincode"
                      required
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <div className="container-box">
        <div className="container-box-top-header justify-content-between">
          <h4>Investment Details</h4>
        </div>
        <div className="container-box-inner px-4">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Property to Invest In</label>
                    <select className="form-select" name="property" value={formValues.property} onChange={handleInputChange}>
                      <option value="">Select  property name</option>
                      {cottage.map((property) => (
                        <option key={property._id} value={property._id}>
                          {property.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Investment Amount</label>
                    <input
                      type="text"
                      name="investmentAmount"
                      className="form-control"
                      value={formValues.investmentAmount}
                      onChange={handleInputChange}
                      placeholder="Enter Investment Amount"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Investment Date</label>
                    <input
                      type="date"
                      name="investmentDate"
                      className="form-control"
                      value={formValues.title}
                      onChange={handleInputChange}
                      placeholder="investmentDate"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div> */}
      <div className="container-box">
        <div className="container-box-top-header justify-content-between">
          <h4>Bank Details</h4>
        </div>
        <div className="container-box-inner px-4">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>Account Holder Name*</label>
                    <input
                      type="text"
                   
                      name="accountHolderName"
                      className="form-control"
                      value={formValues.accountHolderName}
                      onChange={handleInputChange}
                      placeholder="Enter Account Holder Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>Bank Account Number*</label>
                    <input
                      type="text"
                      maxLength={12}
                      name="accountNo"
                      className="form-control"
                      value={formValues.accountNo}
                      onChange={handleInputChange}
                      placeholder="Enter Bank Account Number"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>Bank Name*</label>
                    <input
                      type="text"
                      name="bankName"
                      className="form-control"
                      value={formValues.bankName}
                      onChange={handleInputChange}
                      placeholder="Enter Bank Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>IFSC Code*</label>
                    <input
                      type="text"
                      name="ifscCode"
                      className="form-control"
                      value={formValues.ifscCode}
                      onChange={handleInputChange}
                      placeholder="Enter IFSC Code"
                      required
                    />
                  </div>
                </div>
              </div>
              <button className="site-btn-green" type="submit">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddInvestor;
